<nav>
  <ul class="footer-menu__list">
    <ng-container
      [ngTemplateOutlet]="menu"
      [ngTemplateOutletContext]="{ menuItems: menuItems }"
    ></ng-container>
  </ul>
</nav>

<ng-template #menu let-menuItems="menuItems">
  <footer-menu-item
    *ngFor="let menuItem of menuItems"
    [menuItem]="menuItem"
    [root]="true"
  ></footer-menu-item>
</ng-template>
